import { ShopByList } from './ShopByList';

export default ShopByList;
